import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {RewardModel} from "./RewardModel";

export class RewardBunch extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(RewardBunch, v) : SKIP;
            },
            (v) => {
                return deserialize(RewardBunch, v);
            }
        );
    }

    constructor() {
        super();
        this._items = [];
    }

    get items() {
        return this._items;
    }

    set items(value) {
        this._items = value;
    }

    get count(){
        return !this.items ? 0 : this.items.length;
    }

    valid() {

        if (this.items && this.items.some(v => !v || !v.valid() || v.empty())) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.items || this.items.length === 0;
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new RewardBunch());
        } else if (target instanceof RewardBunch) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(RewardBunch, {
    _items: alias("items", list(RewardModel.schema()))
})